<ng-template>
    <div (click)="closed.emit()" class="w-full bg-white rounded-b">
        <ng-content></ng-content>
    </div>
</ng-template>